/**
 * Ustawienia
 *
 * @export
 * @class ApplicationConfig
 */
export class ApplicationConfig {
    constructor() {
        /**
         * Ilość elementów na stronie
         *
         * @type {number}
         * @memberof ApplicationConfig
         */
        this.onPage = 16;
        /**
         * Wymiary grafik
         *
         * @type {{ [s: string]: { [s: string]: SizeInfo } }}
         * @memberof ApplicationConfig
         */
        this.sizes = {
            avatar: {
                small: { width: 120, height: 120 },
                medium: { width: 180, height: 180 }
            },
            card: {
                small: { width: 270, height: 180 },
                medium: { width: 350, height: 250 }
            },
            gallery: {
                small: { height: 120 },
                big: { height: 415 }
            }
        };
        Object.values(this.sizes).forEach(type => Object.values(type).forEach((sizeItem) => (sizeItem.queryString = Object.keys(sizeItem)
            .map(dimension => `${dimension}=${sizeItem[dimension]}`)
            .join('&'))));
    }
}
export const sharedConfig = new ApplicationConfig();
//# sourceMappingURL=applicationConfig.js.map